<template>
  <q-card flat bordered class="row q-pa-xs q-my-sm">
    <div class="col-md-6 col-12 q-pr-xs">
      <q-table
        :class="
          this.$q.dark.mode === true
            ? 'table-sticky-header-column-dark'
            : 'table-sticky-header-column-them'
        "
        bordered
        :rows="marketDaily"
        :columns="columnsMarketDaily"
        binary-state-sort
        :pagination="pagination"
        @row-click="onClickSectorRow"
        :grid-header="true"
        hide-bottom
      >
        <template v-slot:body-cell="props">
          <q-td
            style="padding: 4px"
            :props="props"
            :class="
              this.$q.dark.mode === true
                ? props.row.symbol == selectedIndexSymbol
                  ? 'bg-grey-9'
                  : ''
                : props.row.symbol == selectedIndexSymbol
                ? 'bg-green-1'
                : ''
            "
          >
            <div class="row">
              <div class="col">
                {{ props.value }}
              </div>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="col-md-6 col-12 q-pl-xs">
      <q-table
        title="Top Gainer"
        :class="
          this.$q.dark.mode === true
            ? 'table-sticky-header-column-dark'
            : 'table-sticky-header-column-them'
        "
        :header-class="'text-bold text-h6'"
        flat
        bordered
        :grid-header="true"
        :rows="topGainersDaily"
        :columns="columnsTopGainersDaily"
        :pagination="paginationTopGainers"
        binary-state-sort
        hide-bottom
      >
        <template v-slot:body-cell="props">
          <q-td :props="props" style="padding: 4px">
            <q-item
              dense
              class="row"
              style="cursor: pointer"
              clickable
              :to="{
                path: '/stock-details',
                query: { symbol: props.value },
              }"
            >
              <div class="col">
                {{ props.value }}
                <!-- <q-tooltip>{{
                    allStocks.find((stock) => stock.symbol == props.value)?.name
                  }}</q-tooltip> -->
              </div>
            </q-item>
          </q-td>
        </template>
      </q-table>
      <q-card flat bordered class="q-mt-md">
        <q-table
          title="Top Looser"
          :class="
            this.$q.dark.mode === true
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column-them'
          "
          fla
          :pagination="paginationTopLosers"
          :rows="topLosersDaily"
          :columns="columnsTopLosersDaily"
          binary-state-sort
          :grid-header="true"
          hide-bottom
        >
          <template v-slot:body-cell="props">
            <q-td :props="props" style="padding: 8px">
              <q-item
                class="row"
                dense
                style="cursor: pointer"
                clickable
                :to="{
                  path: '/stock-details',
                  query: { symbol: props.value },
                }"
              >
                <div class="col">
                  {{ props.value }}
                  <q-tooltip>{{
                    allStocks.find((stock) => stock.symbol == props.value)?.name
                  }}</q-tooltip>
                </div>
              </q-item>
            </q-td>
          </template>
        </q-table>
      </q-card>
    </div>
  </q-card>
</template>
<script>
import { ref, onMounted, defineAsyncComponent } from "vue";

import useData from "src/use/data";
import useUtils from "src/use/utils";
import useCore from "src/use/core";

export default {
  emits: ["clickSectorRow"],
  props: {},
  components: {},
  setup(props, context) {
    const {
      historyDataSearch,
      intraStockPerformance,
      indexPerformance,
      stockPerformance,
    } = useData();
    const { allIndex, allSector } = useCore();
    const { allIndexs } = useUtils();

    const marketDaily = ref([]);
    const topGainersDaily = ref([]);
    const topLosersDaily = ref([]);
    const skipIndices = ref(["SENSFLTIND", "SENSIND", "FLOATIND"]);
    const selectedIndexSymbol = ref("NEPSE");
    const sectors = ref([]);

    allSector().then((res) => {
      sectors.value = res.data;
    });

    indexPerformance().then((res) => {
      marketDaily.value = res.data
        .filter((i) => !skipIndices.value.includes(i.symbol))
        .map((item) => {
          return {
            symbol: item.symbol,

            name: allIndexs().find((i) => {
              return i.symbol === item.symbol;
            }).name,
            close: item.close ?? 0,
            prev_close: item.prev_close ?? 0,
            point_change: item.point_change ?? 0,
            percentage_change: item.percentage_change ?? 0,
            amount: item.amount ?? 0,
            amount_change_daily: item.amount_change_daily ?? 0,
          };
        })
        .sort((a, b) => b.amount - a.amount);
    });

    stockPerformance().then((res) => {
      let dailyPerformance = res.data
        .map((item) => {
          return {
            symbol: item.symbol,
            close: item.close ?? 0,
            prev_close: item.prev_close ?? 0,
            percentage_change: item.percentage_change ?? 0,
            point_change: item.point_change ?? 0,
            amount: item.amount ?? 0,
            amount_change_daily: item.amount_change_daily ?? 0,
          };
        })
        .sort((a, b) => b.percentage_change - a.percentage_change);

      topLosersDaily.value = dailyPerformance
        .filter((item) => item.percentage_change < 0)
        .reverse()
        .slice(0, 5);

      topGainersDaily.value = dailyPerformance
        .filter((item) => item.percentage_change > 0)
        .slice(0, 5);
    });

    const columnsMarketDaily = [
      {
        name: "name",
        label: "Name",
        field: "name",
        align: "left",
        style: "max-width:60px;min-width:60px;padding:4px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
      },
      // {
      //   name: "prev_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   align: "center",
      //   sortable: true,
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return `${parseFloat(val).toFixed(2)} `;
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
      },
      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        align: "center",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "turnover",
        label: "Amt(Cr)",
        field: "amount",
        align: "center",
        sortable: true,
        style: "max-width: 10px",

        format: (val, row) => {
          return parseFloat(val / 10000000).toFixed(2);
        },
      },
      {
        name: "amount_change_daily",
        label: "Amt.CH %",
        field: "amount_change_daily",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_daily) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];

    const columnsTopGainersDaily = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",

        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "prev_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
        align: "center",
      },

      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amt(Cr)",
        field: "amount",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
      {
        name: "amount_change_daily",
        label: "Amt.CH %",
        field: "amount_change_daily",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_daily) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];

    const columnsTopLosersDaily = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "min-width: 50px;padding:0px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "prev_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
        align: "center",
      },

      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amt(Cr)",
        field: "amount",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
      {
        name: "amount_change_daily",
        label: "Amt.CH %",
        field: "amount_change_daily",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_daily) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];

    const pagination = ref({
      rowsPerPage: 14,
      sortBy: "turnover",
      descending: true,
    });

    const paginationTopGainers = ref({
      sortBy: "percentage_change",
      descending: true,
      rowsPerPage: 10,
    });

    const paginationTopLosers = ref({
      sortBy: "percentage_change",
      descending: false,
      rowsPerPage: 10,
    });

    function onClickSectorRow(evt, row) {
      selectedIndexSymbol.value = row.symbol;
      if (row.symbol == "NEPSE") {
        context.emit("clickSectorRow", null);
        return;
      }

      var indexId = allIndexs().find((item) => {
        return item.name == row.name;
      }).id;

      var sectorId = sectors.value.find((item) => item.index == indexId).id;
      var sectorSymbol = allIndexs().find((item) => item.id == indexId).symbol;

      context.emit("clickSectorRow", { sectorSymbol, sectorId });
    }

    return {
      marketDaily,
      topGainersDaily,
      topLosersDaily,
      columnsMarketDaily,
      columnsTopGainersDaily,
      columnsTopLosersDaily,

      pagination,
      paginationTopGainers,
      paginationTopLosers,
      onClickSectorRow,
      selectedIndexSymbol,
    };
  },
};
</script>
